import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-ios-help',
  templateUrl: './ios-help.component.html',
  styleUrls: ['./ios-help.component.css']
})
export class IosHelpComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<IosHelpComponent>) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
